module.exports = __webpack_public_path__ + "img/rankup.81acf743.png";